'use client';

import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function HeroSection() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Full-width Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="relative w-full h-full bg-gradient-to-br from-green-900 to-green-700">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1612170153139-6f881ff067e0?w=1920')] bg-cover bg-center opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-b from-green-900/90 via-green-800/80 to-green-900/90" />
        </div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto text-center pt-32 pb-20 px-6">
       
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2.5 mb-8 reveal">
          <div className="w-2 h-2 rounded-full bg-white animate-pulse" />
          <span className="text-sm font-semibold text-white">Contact & Partnerships</span>
        </div>

        <h1 className="text-heading-1 md:text-[3.75rem] lg:text-[4.5rem] leading-[1.1] text-white mb-6 reveal">
          Let's <span className="text-white">Connect</span>
        </h1>

        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed reveal" style={{ animationDelay: '0.2s' }}>
          Whether you're a farmer seeking premium nutrition solutions or a distributor looking for partnership opportunities, we're here to help.
        </p>

        {/* Contact Info Quick Links */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-12 reveal" style={{ animationDelay: '0.3s' }}>
          <a href="tel:0777014115" className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-full hover:bg-white/20 transition-all">
            <Icon name="PhoneIcon" size={20} className="text-white" />
            <span className="text-sm font-semibold text-white">0777 014 115</span>
          </a>
          <a href="tel:0704846600" className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-full hover:bg-white/20 transition-all">
            <Icon name="PhoneIcon" size={20} className="text-white" />
            <span className="text-sm font-semibold text-white">0704 846 600</span>
          </a>
          <a href="mailto:info@bloomanimalfeeds.com" className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-full hover:bg-white/20 transition-all">
            <Icon name="EnvelopeIcon" size={20} className="text-white" />
            <span className="text-sm font-semibold text-white">info@bloomanimalfeeds.com</span>
          </a>
        </div>
      </div>
    </section>
  );
}